import React from 'react';

import { INPUT_MAP } from './form.config';
import { FORM_KEYS } from './form.keys';
import { VALUEDRIVER_TIPS } from '@model';

import Title from '../columnTitle';

const flexStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const checkBoxStyle = {
  ...flexStyle,
  maxHeight: '6rem',
};

// const commonCols = [
//   {
//     title: <Title />,
//     dataIndex: FORM_KEYS.DRAG.key,
//     key: FORM_KEYS.DRAG.key,
//     style: { ...checkBoxStyle, width: '3rem' },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.DRAG.key] },
//   },
//   {
//     title: <Title className="left" isRequired text={FORM_KEYS.TYPE.label} />,
//     dataIndex: FORM_KEYS.TYPE.key,
//     key: FORM_KEYS.TYPE.key,
//     style: { width: '10.5%' },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.TYPE.key] },
//   },
//
//   {
//     title: <Title isRequired text={FORM_KEYS.SYNERGY.label} />,
//     dataIndex: FORM_KEYS.SYNERGY.key,
//     key: FORM_KEYS.SYNERGY.key,
//     style: { width: '10.5%' },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.SYNERGY.key] },
//   },
//   {
//     title: <Title style={flexStyle} text={FORM_KEYS.HAS_LINK.label} />,
//     dataIndex: FORM_KEYS.HAS_LINK.key,
//     key: FORM_KEYS.HAS_LINK.key,
//     style: { width: '4%', ...checkBoxStyle },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.HAS_LINK.key] },
//   },
//   {
//     title: <Title isRequired text={FORM_KEYS.CATEGORY.label} />,
//     dataIndex: FORM_KEYS.CATEGORY.key,
//     key: FORM_KEYS.CATEGORY.key,
//     style: { width: '16.5%' },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.CATEGORY.key] },
//   },
//   {
//     title: <Title text={FORM_KEYS.DES.label} />,
//     dataIndex: FORM_KEYS.DES.key,
//     key: FORM_KEYS.DES.key,
//     style: { width: 'calc(21.5% - 5rem)' },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.RICH_TEXT.key] },
//   },
//   {
//     title: (
//       <Title
//         className="left"
//         isRequired
//         text={FORM_KEYS.PROBABILITY.label}
//         tip={VALUEDRIVER_TIPS[FORM_KEYS.PROBABILITY.key]}
//       />
//     ),
//     dataIndex: FORM_KEYS.PROBABILITY.key,
//     key: FORM_KEYS.PROBABILITY.key,
//     style: { width: '8.5%' },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.PROBABILITY.key] },
//   },
//   {
//     title: (
//       <Title
//         className="left"
//         isRequired
//         text={FORM_KEYS.TIME_TO_ACHIEVE.label}
//         tip={VALUEDRIVER_TIPS[FORM_KEYS.TIME_TO_ACHIEVE.key]}
//       />
//     ),
//     dataIndex: FORM_KEYS.TIME_TO_ACHIEVE.key,
//     key: FORM_KEYS.TIME_TO_ACHIEVE.key,
//     formConfig: { ...INPUT_MAP[FORM_KEYS.TIME_TO_ACHIEVE.key] },
//     style: { width: '9%' },
//   },
// ];
//
// export const columnsOfDollar = [
//   ...commonCols,
//   {
//     title: (
//       <Title
//         className="left"
//         isRequired
//         text={FORM_KEYS.FINANCIALIMPACT_DOLLAR.label}
//         tip={VALUEDRIVER_TIPS[FORM_KEYS.FINANCIALIMPACT_DOLLAR.key]}
//       />
//     ),
//     dataIndex: FORM_KEYS.FINANCIALIMPACT_DOLLAR.key,
//     key: FORM_KEYS.FINANCIALIMPACT_DOLLAR.key,
//     formConfig: { ...INPUT_MAP[FORM_KEYS.FINANCIALIMPACT_DOLLAR.key] },
//     style: { width: '9%' },
//   },
//   {
//     title: (
//       <Title
//         className="left"
//         text={FORM_KEYS.ONE_TIME_COST_DOLLAR.label}
//         tip={VALUEDRIVER_TIPS[FORM_KEYS.ONE_TIME_COST_DOLLAR.key]}
//       />
//     ),
//     dataIndex: FORM_KEYS.ONE_TIME_COST_DOLLAR.key,
//     key: FORM_KEYS.ONE_TIME_COST_DOLLAR.key,
//     formConfig: { ...INPUT_MAP[FORM_KEYS.ONE_TIME_COST_DOLLAR.key] },
//     style: { width: '9%' },
//   },
//   {
//     dataIndex: FORM_KEYS.DELETE.key,
//     key: FORM_KEYS.DELETE.key,
//     style: {
//       ...flexStyle,
//       width: '2rem',
//     },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.DELETE.key] },
//
//     //
//   },
// ];
//
// export const columnsOfScale = [
//   ...commonCols,
//   {
//     title: (
//       <Title
//         className="left"
//         isRequired
//         text={FORM_KEYS.FINANCIALIMPACT_SCALE.label}
//         tip={VALUEDRIVER_TIPS[FORM_KEYS.FINANCIALIMPACT_SCALE.key]}
//       />
//     ),
//     dataIndex: FORM_KEYS.FINANCIALIMPACT_SCALE.key,
//     key: FORM_KEYS.FINANCIALIMPACT_SCALE.key,
//     formConfig: { ...INPUT_MAP[FORM_KEYS.FINANCIALIMPACT_SCALE.key] },
//     style: { width: '9%' },
//   },
//   {
//     title: (
//       <Title
//         className="left"
//         text={FORM_KEYS.ONE_TIME_COST_SCALE.label}
//         tip={VALUEDRIVER_TIPS[FORM_KEYS.ONE_TIME_COST_SCALE.key]}
//       />
//     ),
//     dataIndex: FORM_KEYS.ONE_TIME_COST_SCALE.key,
//     key: FORM_KEYS.ONE_TIME_COST_SCALE.key,
//     formConfig: { ...INPUT_MAP[FORM_KEYS.ONE_TIME_COST_SCALE.key] },
//     style: { width: '9%' },
//   },
//   {
//     dataIndex: FORM_KEYS.DELETE.key,
//     key: FORM_KEYS.DELETE.key,
//     style: {
//       ...flexStyle,
//       width: '2rem',
//     },
//     formConfig: { ...INPUT_MAP[FORM_KEYS.DELETE.key] },
//
//     //
//   },
// ];

export const valuerDriverEditColumn = [
  {
    title: <Title />,
    dataIndex: FORM_KEYS.DRAG.key,
    key: FORM_KEYS.DRAG.key,
    style: { ...checkBoxStyle, width: '3rem' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DRAG.key] },
  },
  {
    title: <Title className="left" isRequired text={FORM_KEYS.TYPE.label} />,
    dataIndex: FORM_KEYS.TYPE.key,
    key: FORM_KEYS.TYPE.key,
    style: { width: '10.5%' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.TYPE.key] },
  },

  {
    title: <Title isRequired text={FORM_KEYS.SYNERGY.label} />,
    dataIndex: FORM_KEYS.SYNERGY.key,
    key: FORM_KEYS.SYNERGY.key,
    style: { width: '10.5%' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.SYNERGY.key] },
  },
  {
    title: <Title style={flexStyle} text={FORM_KEYS.HAS_LINK.label} />,
    dataIndex: FORM_KEYS.HAS_LINK.key,
    key: FORM_KEYS.HAS_LINK.key,
    style: { width: '4%', ...checkBoxStyle },
    formConfig: { ...INPUT_MAP[FORM_KEYS.HAS_LINK.key] },
  },
  {
    title: <Title isRequired text={FORM_KEYS.CATEGORY.label} />,
    dataIndex: FORM_KEYS.CATEGORY.key,
    key: FORM_KEYS.CATEGORY.key,
    style: { width: '16.5%' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.CATEGORY.key] },
  },
  {
    title: <Title text={FORM_KEYS.DES.label} />,
    dataIndex: FORM_KEYS.DES.key,
    key: FORM_KEYS.DES.key,
    style: { width: 'calc(21.5% - 5rem)' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.RICH_TEXT.key] },
  },
  {
    title: (
      <Title
        className="left"
        isRequired
        text={FORM_KEYS.PROBABILITY.label}
        tip={VALUEDRIVER_TIPS[FORM_KEYS.PROBABILITY.key]}
      />
    ),
    dataIndex: FORM_KEYS.PROBABILITY.key,
    key: FORM_KEYS.PROBABILITY.key,
    style: { width: '8.5%' },
    formConfig: { ...INPUT_MAP[FORM_KEYS.PROBABILITY.key] },
  },
  {
    title: (
      <Title
        className="left"
        isRequired
        text={FORM_KEYS.TIME_TO_ACHIEVE.label}
        tip={VALUEDRIVER_TIPS[FORM_KEYS.TIME_TO_ACHIEVE.key]}
      />
    ),
    dataIndex: FORM_KEYS.TIME_TO_ACHIEVE.key,
    key: FORM_KEYS.TIME_TO_ACHIEVE.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.TIME_TO_ACHIEVE.key] },
    style: { width: '9%' },
  },
  {
    title: (
      <Title
        className="left"
        isRequired
        text={FORM_KEYS.FINANCIAL_IMPACT.label}
        tip={VALUEDRIVER_TIPS[FORM_KEYS.FINANCIAL_IMPACT.key]}
      />
    ),
    dataIndex: FORM_KEYS.FINANCIAL_IMPACT.key,
    key: FORM_KEYS.FINANCIAL_IMPACT.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.FINANCIAL_IMPACT.key] },
    style: { width: '9%' },
  },
  {
    title: (
      <Title
        className="left"
        text={FORM_KEYS.ONE_TIME_COST.label}
        tip={VALUEDRIVER_TIPS[FORM_KEYS.ONE_TIME_COST.key]}
      />
    ),
    dataIndex: FORM_KEYS.ONE_TIME_COST.key,
    key: FORM_KEYS.ONE_TIME_COST.key,
    formConfig: { ...INPUT_MAP[FORM_KEYS.ONE_TIME_COST.key] },
    style: { width: '9%' },
  },
  {
    dataIndex: FORM_KEYS.DELETE.key,
    key: FORM_KEYS.DELETE.key,
    style: {
      ...flexStyle,
      width: '2.25rem',
    },
    formConfig: { ...INPUT_MAP[FORM_KEYS.DELETE.key] },

    //
  },
];

export const getDefaultRowData = (data = {}) => ({
  [FORM_KEYS.COLOR.key]: '',
  [FORM_KEYS.DISPLAY.key]: false,
  [FORM_KEYS.IFRAME.key]: false,
  ...data,
});
